import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=248d4ef2&scoped=true&"
import script from "./LocaleSelect.vue?vue&type=script&lang=ts&"
export * from "./LocaleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&id=248d4ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d4ef2",
  null
  
)

export default component.exports